<template>
  <v-container>
    <PageHeader subtitle="Operation logs for continuous data API." />
    <AquariusServerStatus></AquariusServerStatus>
    <br>
    <Subheader title="Aquarius Logs" no-search></Subheader>
    <v-card>
      <v-card-text>
        <v-card>
          <v-card-text>
            <v-layout>
              <v-flex xs12 lg6>
                <DateRange v-model="dates" rounded solo :minDate="MinDate" :maxDate="MaxDate"
                  :availableDateRange="{ start: MinDate, end: MaxDate }" :min-max-placeholder="formats.prettyDateFormat"
                  :shortcuts="shortcuts" no-arrows :data="availableData" :showAvailableText="false" />
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 lg6 class="pa-1">
                <v-select outline v-model="selectServer" label="Aquarius Server" :items="serverItem" hide-details clearable></v-select>
              </v-flex>
              <v-flex xs12 lg6 class="pa-1">
                <v-select outline v-model="selectAPIEndpoint" label="API Endpoint" :items="apiItem" hide-details clearable></v-select>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex  xs12 lg12 class="pa-1">
                <v-text-field outline v-model="queryString" label="Enter Search term" clearable></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-checkbox v-model="errorsOnly" label="Errors only"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="selectLogs();page=1" style="margin-left: 5px;">
              <v-icon left>search</v-icon>Search
            </v-btn>
            <v-btn color="warning" @click="clearAll()" style="margin-left: 5px;">
              <v-icon left>autorenew</v-icon>Clear All
            </v-btn>
          </v-card-actions>
          <div v-if="searchLoading">
            <br><v-progress-linear v-if="!searchFinish" :indeterminate="true"></v-progress-linear>
          </div>
          <v-divider></v-divider>
          
          <v-card-text v-if="searchFinish">
            <v-subheader>Filters:</v-subheader>
            <v-chip disabled style="margin-left: 15px;"><v-icon color="primary">bookmark</v-icon>Date Time: {{selectItem.showDateTime}}</v-chip>
            <v-chip disabled style="margin-left: 15px;" v-if="selectItem.selectServer"><v-icon color="primary">bookmark</v-icon>Server: {{selectItem.selectServer}}</v-chip>
            <v-chip disabled style="margin-left: 15px;" v-if="selectItem.selectAPIEndpoint"><v-icon color="primary">bookmark</v-icon>API Endpoint: {{selectItem.selectAPIEndpoint}}</v-chip>
            <v-chip disabled style="margin-left: 15px;" v-if="selectItem.errorsOnly"><v-icon color="primary">bookmark</v-icon>Errors Only: {{selectItem.errorsOnly}}</v-chip>
            <v-chip disabled style="margin-left: 15px;" v-if="selectItem.queryString"><v-icon color="primary">bookmark</v-icon>Search Term: {{selectItem.queryString}}</v-chip>   
            <v-subheader>Results:</v-subheader>
            <v-chip disabled style="margin-left: 15px;"><v-icon color="primary">pageview</v-icon>{{logsNum}} Logs</v-chip>
            <v-divider></v-divider>
            <v-expansion-panel focusable>
              <v-expansion-panel-content v-for="(item,i) in searchResults" :key="i">
                <template v-slot:header>
                  <v-layout row wrap>
                    <v-flex xs3 class="word_wrap"><v-icon :color="item.Level.toLowerCase()">{{item.Level.toLowerCase()}}</v-icon> Level: {{item.Level}}</v-flex>
                    <v-flex xs3 class="word_wrap">DateTime: {{showResultsTime(item.DateTime)}}</v-flex>
                    <v-flex xs3 class="word_wrap">Server: {{item.AquariusServer}}</v-flex>
                    <v-flex xs3 class="word_wrap"API Endpoint: {{item.ApiEndpoint}}</v-flex>
                  </v-layout>
                </template>
                <v-card>
                  <v-card-text :class="result_theme(item.Level.toLowerCase())" class="grey lighten-3">
                    <v-layout row wrap>
                      <v-flex xs2>Tenant:</v-flex>
                      <v-flex xs10 class="word_wrap">{{item.Tenant}}</v-flex>
                      <v-flex xs2>Request Data:</v-flex>
                      <v-flex xs10 class="word_wrap">{{item.RequestData}}</v-flex>
                      <v-flex xs2>Notes:</v-flex>
                      <v-flex xs10 class="word_wrap">{{item.Notes}}</v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel><br>
            <div class="text-xs-center">
              <v-pagination v-model="page" :length="pageLength" :total-visible="7"></v-pagination>
            </div>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>

    <app-confirmation-modal v-model="searchError" max-width="500">
      <template slot="app-modal-title">ERROR</template>
      <template slot="app-modal-text">
        {{ errorMessage }}
      </template>
      <template slot="app-modal-actions">
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="searchError = false" outline>Cancel</v-btn>
      </template>
    </app-confirmation-modal>
        
    <v-card color="grey lighten-4">
      <v-snackbar
        style="text-align:center"
        :color="snackColor"
        :timeout="null"
        top
        v-model="snackbar"
      >
        {{ snackMessage }}
        <v-btn dark flat @click.native="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
import PageHeader from '@/components/generic/PageHeader'
import Subheader from '@/components/generic/Subheader'
import DateRange from '@/components/generic/DateRange'
import AppConfirmationModal from '@/components/generic/AppConfirmationModal'
import AquariusServerStatus from '@/components/AquariusLogs/AquariusServerStatus'
import moment from 'moment'
import { createNamespacedHelpers } from 'vuex'
import { format } from 'date-fns'
import { prettyDateFormat, prettyDateTimeFormat } from '@/components/mixins/MomentUtil'
const logging =  createNamespacedHelpers('logging')

export default {
  components: {
    PageHeader,
    Subheader,
    DateRange,
    AquariusServerStatus,
    'app-confirmation-modal': AppConfirmationModal,
  },
  data() {
    return {
      searchError: false,
      errorMessage: '',
      snackColor: '',
      snackMessage: '',
      snackbar: false,
      serverItem: ['AquariusNG'],
      apiItem: [
        'Authentication',
        'GetContinuousLocationList',
        'GetContinuousLocationDetail',
        'ContinuousDataReport',
        'DiscreteSampleDataReport',
      ].sort(),
      selectServer: 'AquariusNG',
      queryString: null,
      selectAPIEndpoint: '',
      errorsOnly: false,
      startDate: null,
      endDate: null,
      startDateMenu: false,
      endDateMenu: false,
      minDate: null,
      maxDate: null,
      formats: {
        prettyDateFormat,
      },
      availableData: [],
      dates: {
        start: null,
        end: null,
      },
      selectItem: {
        showDateTime: null,
        selectServer: '',
        selectAPIEndpoint: '',
        errorsOnly: false,
        queryString: '',
      },
      searchLoading: false,
      searchFinish: false,
      searchResults: [],
      startIndex: 0,
      page: 1,
    }
  },
  computed: {
    ...logging.mapGetters(['ContinuousLogs']),
    shortcuts() {
      return {
        all: {
          hideClear: false,
          name: () => 'Select Date Time',
          hidden: true,
        },
      }
    },
    MinDate() {
      return moment(this.minDate).toDate()
    },
    MaxDate() {
      return moment(this.minDate).toDate()
    },
    showDateTime() {
      return `${format(this.dates.start, 'MMM DD, YYYY')} → ${format(this.dates.end, 'MMM DD, YYYY')}`
    },
    pageLength() {
      if (this.ContinuousLogs.TotalNumber < 10) {
        return 1
      }
      else {
        return Math.ceil(this.ContinuousLogs.TotalNumber / 10)
      }
    },
    logsNum() {
      let startNum
      let endNum
      if (this.ContinuousLogs.TotalNumber == 0) {
        return 0
      }
      else if (this.ContinuousLogs.TotalNumber < 10) {
        startNum = 1
        endNum = this.ContinuousLogs.TotalNumber
      }
      else {
        startNum = this.ContinuousLogs.StartIndex + 1
        endNum = this.page*10 < this.ContinuousLogs.TotalNumber ? this.page*10 : this.ContinuousLogs.TotalNumber
      }
      return `${startNum}-${endNum} of ${this.ContinuousLogs.TotalNumber}`
    },
  },
  watch: {
    page() {
      this.startIndex = (this.page-1)*10
      this.selectLogs()
    },
  },
  methods: {
    ...logging.mapActions(['getContinuousLogs']),
    result_theme(level) {
      if (level == 'info') {
        return 'theme_info'
      }
      else if (level == 'warning') {
        return 'theme_warning'
      }
      else if (level == 'error') {
        return 'theme_error'
      }
    },
    showResultsTime(DateTime) {
      return format(DateTime, prettyDateTimeFormat)
    },
    async selectLogs() {
      let start = format(this.dates.start, 'YYYY-MM-DD')
      let end = format(this.dates.end, 'YYYY-MM-DD')
      let noDateTime = (start == '1970-01-01') || (end == '1970-01-01')
      if (noDateTime) {
        this.snackMessage = 'Please specify the date time for the query criteria.'
        this.snackColor = 'info'
        this.snackbar = true
      }
      else {
        this.searchFinish = false
        this.searchLoading = true
        let options = {
          data: {
            StartDateTime: start,
            EndDateTime: end,
            AquariusServer: this.selectServer,
            ApiEndpoint: this.selectAPIEndpoint,
            ErrorsOnly: this.errorsOnly,
            StartIndex: this.startIndex,
            QueryString: this.queryString,
            Limit: 10,
          },
          successCb:() => {
            this.selectItem = {
              showDateTime: this.showDateTime,
              selectServer: this.selectServer,
              selectAPIEndpoint: this.selectAPIEndpoint,
              errorsOnly: this.errorsOnly,
              queryString: this.queryString,
            }
            this.searchResults = this.ContinuousLogs.Data
            this.searchFinish = true
            this.searchLoading = false
          },
          failedCb:(error) => {
            console.error(error)
            this.searchLoading = false
            this.searchError = true
            this.errorMessage = error
          },
        }
        this.getContinuousLogs(options)
      }
    },
    clearAll() {
      this.searchFinish = false
      this.selectServer = ''
      this.selectAPIEndpoint = ''
      this.dates = {
        start: null,
        end: null,
      }
      this.errorsOnly = false
      this.QueryString = null
      this.searchResults = []
      this.selectItem = {
        showDateTime: null,
        selectServer: '',
        selectAPIEndpoint: '',
        errorsOnly: false,
        queryString: '',
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
  .theme_info {
    border: 3px solid #2196f3 !important;
  }
  .theme_warning {
    border: 3px solid #FFC107 !important;
  }
  .theme_error {
    border: 3px solid #b71c1c !important;
  }
  .word_wrap {
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
  }
</style>
